import React from "react";
import { Dialog } from "@mui/material";
import "./AllCelebration.scss";
import { Celebrations } from "../../utility/interfaces/carePlanInterfaces";
import { CelebrationCode } from "../../utility/constants/common-constants";
import { TierUnlocked } from "./TierUnlocked";
import { BabyBorn } from "./BabyBorn";
import { RewardClaimed } from "./RewardClaimed";
import { TrimesterCompleted } from "./TrimesterCompleted";
import { FirstLogin } from "./FirstLogin";

interface AllCelebrationProps {
  open: boolean;
  onClose: (celebration: Celebrations) => void;
  celebration: Celebrations;
}
const AllCelebration: React.FC<AllCelebrationProps> = ({
  open,
  onClose,
  celebration,
}) => {
  return (
    <Dialog
      open={true}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      PaperProps={{
        sx: { borderRadius: "10px" },
      }}
    >
      <div className="milestone-app">
        <div className="modal-stack">
          {/* MODAL 1: Welcome Bonus */}

          {celebration.eventCode === CelebrationCode.FIRST_LOGIN && (
            <FirstLogin
              onClose={() => onClose(celebration)}
              celebration={celebration}
            />
          )}

          {/* MODAL 2: Trimester Completion */}

          {(celebration.eventCode === CelebrationCode.FIRST_TRI_COMPLETED ||
            celebration.eventCode === CelebrationCode.SECOND_TRI_COMPLETED) && (
            <TrimesterCompleted
              onClose={() => onClose(celebration)}
              celebration={celebration}
            />
          )}

          {/* MODAL 3: Reward Claimed  */}

          {celebration.eventCode === CelebrationCode.REWARD_CLAIMED && (
            <RewardClaimed
              onClose={() => onClose(celebration)}
              celebration={celebration}
            />
          )}

          {/* MODAL 4: Delivery (Birth Milestone)*/}

          {celebration.eventCode === CelebrationCode.BABY_BORN && (
            <BabyBorn
              onClose={() => onClose(celebration)}
              celebration={celebration}
            />
          )}

          {/* MODAL 5: Tier Unlock  */}

          {(celebration.eventCode === CelebrationCode.PEARL ||
            celebration.eventCode === CelebrationCode.DIAMOND ||
            celebration.eventCode === CelebrationCode.EMERALD) && (
            <TierUnlocked
              onClose={() => onClose(celebration)}
              celebration={celebration}
            />
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default AllCelebration;
